import _ from 'lodash';

// Valid supported input types
const TYPES = [
  'text',
  'password',
  'email',
  'number',
  'url',
  'tel',
  'search',
  'range',
  'color',
  'date',
  'time',
  'datetime',
  'datetime-local',
  'month',
  'week',
  'dollar',
  'percentage',
];

// valid support states
const STATES = ['', 'error', 'success', 'disabled'];

const arrayIncludes = (array, value) => array.indexOf(value) !== -1;

export default {
  name: 'MInput',
  props: {
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      default: null,
      required: true,
      validator(value) {
        return (
          value === null
          || typeof value === 'string'
          || value instanceof String
          || typeof value === 'number'
        );
      },
    },
    type: {
      type: String,
      default: 'text',
      validator: type => arrayIncludes(TYPES, type),
    },
    state: {
      type: String,
      default: '',
      validator: state => arrayIncludes(STATES, state),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    iconAlign: {
      type: String,
      default: '',
    },
  },
  watch: {
    type(newVal) {
      this.setLocalType(newVal);
    },
  },
  data() {
    return {
      getLocalType: this.type,
    };
  },
  methods: {
    showHidePassword() {
      const toggled = this.$refs.toggler;
      if (this.getLocalType === 'password') {
        this.setLocalType('text');
        toggled.classList.add('fa-eye-slash');
      } else {
        toggled.classList.remove('fa-eye-slash');
        this.setLocalType('password');
      }
    },
    setLocalType(newType) {
      this.getLocalType = newType;
    },
  },
  computed: {
    hasOptions() {
      return _.isEqual(this.options, {});
    },
    hasSymbolSlot() {
      return !!this.$slots.symbol;
    },
    isPasswordType() {
      return (this.id === 'password-input' || this.id === 'confirm-password-input');
    },
    getClasses() {
      let classes = 'form-input w-full text-gray-700';

      if (this.symbol) {
        classes += ' pl-12';
      }
      if (this.state === 'success') {
        classes += ' border border-green-500 bg-green-200 text-green-700 placeholder-green-700';
      } else if (this.state === 'error') {
        classes += ' border border-red-500 bg-red-200 text-red-600 placeholder-red-600';
      } else if (this.state === 'disabled') {
        classes += ' bg-gray-300';
      }

      return classes;
    },
    localType() {
      // We only allow certain types
      const localType = arrayIncludes(TYPES, this.type) ? this.type : 'text';
      if (localType === 'dollar' || localType === 'percentage') {
        return 'text';
      }
      this.setLocalType(localType);
      return localType;
    },
    localState() {
      return arrayIncludes(STATES, this.state) ? this.state : '';
    },
  },
};
